import theme from '@/presentation/assets/styles/theme'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
import { i18nTranslationHelper } from '@/i18n'

type SpinnerBackdropAppProps = {
  loading: boolean
  message?: string
  children?: React.ReactNode
}

export default function SpinnerBackdropApp({
  loading,
  message = undefined,
  children
}: SpinnerBackdropAppProps) {
  const text = message || i18nTranslationHelper.getTComponents('spinnerBackdropApp.defaultMessage')
  if (!loading) return
  return (
    <Backdrop
      sx={{
        color: theme.palette.common.white,
        zIndex: theme => theme.zIndex.modal + 1,
        display: 'flex',
        flexDirection: 'column'
      }}
      open={loading}
    >
      <CircularProgress color="inherit" size={60} />
      <Typography variant="subtitle1" sx={{ mt: 2, width: 307, textAlign: 'center' }}>
        {children ?? text}
      </Typography>
    </Backdrop>
  )
}
